import { Component, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { AuthGuardService, AuthService, Role, Session, SessionChangedEventArgs, SessionService, ISessionChangeOptions } from '@yukawa/chain-main-angular-session';
import { RoleAuthService } from './service/roleAuth.service';
import { ThemeService } from './service/theme.service';
import { IEvent } from '@awesome-nodes/object';


const SIGN_IN_URL = 'sign-in';
const DEFAULT_REDIRECT_URL = '/signed-in-redirect';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly _location = inject(Location);
  private _router = inject(Router);
  private readonly _authGuardService = inject(AuthGuardService);
  private _sessionService = inject(SessionService);


  /**
 * Constructor
 */
  constructor() {
    const _sessionService = this._sessionService;

    _sessionService.sessionChanged.subscribe(this.sessionChanged as IEvent<Session, SessionChangedEventArgs>, this);
    _sessionService.auth.loginRequest.subscribe(this.loginRequest, this);
  }

  async ngOnInit(): Promise<void> {
    // Session restoration now happens in APP_INITIALIZER before routing
    // Check if we have authentication state and handle initial navigation
    let command: string | undefined;

    if (this._sessionService.auth.isAuthenticated) {
      if (this._authGuardService.lastForbiddenRoute) {
        command = this._authGuardService.lastForbiddenRoute;
      } else {
        const locationPath = this._location.path(true);
        if (locationPath !== '' && locationPath !== '/') {
          command = locationPath;
        }
      }
    }

    if (!(await this.initialNavigation(command))) {
      if (this._sessionService.auth.isAuthenticated) {
        this._sessionService.logout();
      } else {
        await this._router.navigateByUrl(SIGN_IN_URL);
      }
    }
  }

  public initialNavigation(command?: string): Promise<boolean> {
    const initialRedirectUrl = this.getInitialRedirectUrl();

    // Skip non admins without view rights
    // if (
    //   !this._roleAuthService.hasRole('ROLE_ADMIN') &&
    //   initialRedirectUrl === DEFAULT_REDIRECT_URL
    // ) {
    //   return Promise.resolve(false);
    // }

    return this._router.navigateByUrl(
      command
        ? command
        : initialRedirectUrl
    );
  }


  /**
   * Returns the first navigation item or default redirect url
   *
   * @param  urls
   * @private
   */
  private getInitialRedirectUrl(urls?: string[]): string {
    if (!urls) {
      urls = new Array<string>();
    }
    return urls?.[0] || DEFAULT_REDIRECT_URL;
  }

  private loginRequest(sender: AuthService): void {
    let redirectUrl: string;
    let queryParams = {};
    if (sender.isAuthenticated) {
      redirectUrl = this.getInitialRedirectUrl();
    } else if (this._authGuardService.lastForbiddenRoute) {
      queryParams = { redirectURL: this._authGuardService.lastForbiddenRoute };
    }
    redirectUrl = SIGN_IN_URL;
    this._router.navigate([redirectUrl], { queryParams });
  }

  private async sessionChanged(sender: Session, ea: SessionChangedEventArgs): Promise<void> {
    if (ea.session instanceof Session.SessionDisconnected) {
      if (this._router.navigated) {
        const redirect = async (): Promise<boolean> => await this._router.navigate([SIGN_IN_URL]);

        if (ea.options?.redirectDelay) {
          setTimeout(async () => {
            await redirect();
          }, ea.options?.redirectDelay);
        }
        else {
          await redirect();
        }
      }
    } else if (ea.session instanceof Session.SessionConnected) {
      console.debug('Session connected', ea.session);
    }
  }
}
